import { render, staticRenderFns } from "./Comments.vue?vue&type=template&id=5bdb12c6&"
import script from "./Comments.vue?vue&type=script&lang=js&"
export * from "./Comments.vue?vue&type=script&lang=js&"
import style0 from "./Comments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bdb12c6')) {
      api.createRecord('5bdb12c6', component.options)
    } else {
      api.reload('5bdb12c6', component.options)
    }
    module.hot.accept("./Comments.vue?vue&type=template&id=5bdb12c6&", function () {
      api.rerender('5bdb12c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/trays/managementTray/informationFlow/Comments.vue"
export default component.exports